import cookie from 'react-cookies';

export class Cookies {
    //private path = "http://localhost:3000/";

    /*
    This cookies is used for storing less sensitive info and easy access of sysetm
    Right now we can:
    1.isLogged - track if login
    2.userID 
    3.userName
    4.userType
    5.userFirstName
    6.userLastName
    */
    private setting = false; 
    private path = "https://winz-ticket-system.netlify.app/";
    
    private options =
    {
        path: this.path,
        secure: this.setting,
        httpOnly : this.setting
    }

    Login(){
        cookie.save('isLogged', "true", this.options);
    }

    Logout(){
        cookie.remove('isLogged');
        cookie.remove('userID');
        cookie.remove('userName');
        cookie.remove('userType');  
        cookie.remove('userFirstName');
        cookie.remove('userLastName');
    }

    Set(name: string, data:string){
        cookie.save(name, data, this.options);
    }

    CheckLogin(){
        return cookie.load("isLogged");
    }

    Load(name:string){
        return cookie.load(name);
    }

}